import { Observable, throwError as observableThrowError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { ISGObject, ISGProviderAdapter } from '../_model/isg-object'

@Injectable()
export class ISGService {

    url: string = environment.apiUrl + '/campaign/isg';

    constructor(private http: HttpClient,
        private adapter: ISGProviderAdapter) {
    }

    get(position: any): Observable<ISGObject> {
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');

        let params = new HttpParams();
        params = params.append('src', position.src);
        params = params.append('lat', position.lat);
        params = params.append('lon', position.lon);
        params = params.append('acc', position.acc);
        params = params.append('city', position.city);
        params = params.append('region', position.region);
        params = params.append('cc', position.cc);
        params = params.append('provider', 'w-sc-1');

        return this.http.get(this.url, {headers: headers, params: params})
        .pipe(
            map((data: any[]) => this.adapter.adapt(data))
        )
        .pipe(
            catchError(this.handleErrorObservable)
        );
    }

    private handleErrorObservable(error: HttpErrorResponse) {
        console.error(error.message || error);
        return observableThrowError(error.message || error);
    }

}
